module.exports = __webpack_public_path__ + "static/img/gpt26.12eda4d6.png";